import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=7cc9cd7e&scoped=true"
import script from "./StudentCourse.vue?vue&type=script&lang=js"
export * from "./StudentCourse.vue?vue&type=script&lang=js"
import style0 from "./StudentCourse.vue?vue&type=style&index=0&id=7cc9cd7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9cd7e",
  null
  
)

export default component.exports